// extracted by mini-css-extract-plugin
export default {"wrapper":"xN3SOlu_HJlM1_LiQayx","value":"oNrdBDDIqzhVzKmobYHP","button":"ajihH9hZk156F5sT9vpl"};